var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreDotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-vet-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1482",
    d: "M10.789 13.9346C10.789 13.5987 10.6556 13.2765 10.418 13.039C10.1805 12.8014 9.85832 12.668 9.52238 12.668C9.18644 12.668 8.86426 12.8014 8.62671 13.039C8.38916 13.2765 8.25571 13.5987 8.25571 13.9346C8.25571 14.2706 8.38916 14.5928 8.62671 14.8303C8.86426 15.0679 9.18644 15.2013 9.52238 15.2013C9.85832 15.2013 10.1805 15.0679 10.418 14.8303C10.6556 14.5928 10.789 14.2706 10.789 13.9346ZM10.7606 5.06549C10.7606 4.72955 10.6271 4.40737 10.3896 4.16983C10.1521 3.93228 9.82987 3.79883 9.49393 3.79883C9.15799 3.79883 8.83581 3.93228 8.59826 4.16983C8.36071 4.40737 8.22726 4.72955 8.22726 5.06549C8.22726 5.40144 8.36071 5.72362 8.59826 5.96116C8.83581 6.19871 9.15799 6.33216 9.49393 6.33216C9.82987 6.33216 10.1521 6.19871 10.3896 5.96116C10.6271 5.72362 10.7606 5.40144 10.7606 5.06549ZM10.7445 9.50007C10.7445 9.16412 10.6111 8.84194 10.3735 8.6044C10.136 8.36685 9.81379 8.2334 9.47785 8.2334C9.14191 8.2334 8.81973 8.36685 8.58218 8.6044C8.34463 8.84194 8.21118 9.16412 8.21118 9.50007C8.21118 9.83601 8.34463 10.1582 8.58218 10.3957C8.81973 10.6333 9.14191 10.7667 9.47785 10.7667C9.81379 10.7667 10.136 10.6333 10.3735 10.3957C10.6111 10.1582 10.7445 9.83601 10.7445 9.50007Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDotes);
export default __webpack_public_path__ + "static/media/more-dotes.72a7f738182cbb82bae378f750c073ed.svg";
export { ForwardRef as ReactComponent };